/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import SVG from "react-inlinesvg";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";
import { useSelector } from "react-redux";
import { map, size } from "lodash";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = url => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };
  const listMenu = useSelector(state => state.app.listMenu);

  const renderMenuItem = (menu, isChild = false) => {
    const isMenuHasChild = size(menu.children) > 0;
    let liClassName = `menu-item`;
    let navLinkClassName = `menu-link`;
    if (isMenuHasChild) {
      liClassName += " menu-item-submenu menu-item-rel";
      navLinkClassName += " menu-toggle";
    }
    liClassName += ` ${getMenuItemActive(menu.path, isMenuHasChild)}`;

    return (
      <li
        key={menu.id}
        className={liClassName}
        aria-haspopup="true"
        data-menu-toggle={layoutProps.menuDesktopToggle}
      >
        <NavLink className={navLinkClassName} to={menu.path}>
          <span className="svg-icon menu-icon" title={menu.name}>
            {menu.icon && (
              <SVG title={menu.name} src={toAbsoluteUrl(menu.icon)} />
            )}
          </span>
          <span className="menu-text">{menu.name}</span>
          {isMenuHasChild && <i className="menu-arrow" />}
        </NavLink>
        {isMenuHasChild && (
          <div
            className={`menu-submenu menu-submenu-classic ${!isChild ? "menu-submenu-left" : "menu-submenu-right"}`}
          >
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {menu.children.map(childMenu => renderMenuItem(childMenu, true))}
            </ul>
          </div>
        )}
      </li>
    );
  };

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {listMenu.map(menu => renderMenuItem(menu))}
      </ul>
      {/*end::Header Nav*/}
    </div>
  );
}
